import { render, staticRenderFns } from "./contentTools.vue?vue&type=template&id=18228bc7"
import script from "./contentTools.vue?vue&type=script&lang=js"
export * from "./contentTools.vue?vue&type=script&lang=js"
import style0 from "./contentTools.vue?vue&type=style&index=0&id=18228bc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports